<template>
  <SuccessModal
    :model-value="successStore.showSuccessModal"
    :title="successStore.title"
    :message="successStore.message"
    :icon="successStore.icon"
    :details="successStore.details"
    :details-title="successStore.detailsTitle"
    :buttons="successStore.buttons"
    @update:modelValue="successStore.showSuccessModal = $event"
  />
</template>

<script setup lang="ts">
import { useSuccessMessageStore } from '@/stores/successMessage'
import SuccessModal from '@/components/SuccessModal.vue'

const successStore = useSuccessMessageStore()
</script>
